import React from 'react';
import { CheckCircle2, Package, PhoneCall, ArrowRight } from 'lucide-react';
import { formatMAD, formatMoney } from '@xshop/shared';

interface OrderSuccessProps {
  order: {
    orderNumber: string;
    customerFullName: string;
    customerPhone: string;
    shippingCity: string;
    shippingAddress: string;
    totalPrice: string | number;
    paymentMethod: string;
    currency?: string;
  };
  currency?: string;
  onClose: () => void;
}

// Order confirmation receipt modal with WhatsApp / Call Center confirmation notice
export const OrderSuccess: React.FC<OrderSuccessProps> = ({ order, currency = 'MAD', onClose }) => {
  const activeCurrency = order.currency || currency || 'MAD';
  const displayPrice = (val: number) => activeCurrency === 'MAD' ? formatMAD(val) : formatMoney(val, activeCurrency);

  return (
    <div className="success-overlay">
      <div className="success-modal">
        <div className="success-icon-wrapper">
          <CheckCircle2 size={36} />
        </div>

        <div>
          <h2 style={{ fontSize: 22, fontWeight: 800, color: '#0f172a' }}>
            Merci {order.customerFullName.split(' ')[0]} !
          </h2>
          <p style={{ fontSize: 14, color: '#64748b', marginTop: 4 }}>
            Votre commande a été enregistrée avec succès.
          </p>
        </div>

        <div className="order-number-badge">
          Commande N° {order.orderNumber}
        </div>

        <div className="success-details">
          <div className="success-row">
            <span>Téléphone :</span>
            <strong>{order.customerPhone}</strong>
          </div>
          <div className="success-row">
            <span>Ville de livraison :</span>
            <strong>{order.shippingCity}</strong>
          </div>
          <div className="success-row">
            <span>Adresse :</span>
            <strong>{order.shippingAddress}</strong>
          </div>
          <div className="success-row">
            <span>Mode de paiement :</span>
            <strong style={{ color: '#059669' }}>Paiement à la Livraison</strong>
          </div>
          <div className="success-row" style={{ borderTop: '1px solid #e2e8f0', paddingTop: 6 }}>
            <span>Montant à régler :</span>
            <strong style={{ fontSize: 15, color: '#0f172a' }}>
              {displayPrice(parseFloat(order.totalPrice.toString()))}
            </strong>
          </div>
        </div>

        <div style={{ background: '#ecfdf5', border: '1px solid #a7f3d0', borderRadius: 8, padding: 12, fontSize: 13, color: '#065f46', display: 'flex', alignItems: 'center', gap: 10, textAlign: 'left' }}>
          <PhoneCall size={20} style={{ flexShrink: 0 }} />
          <div>
            <strong>Gardez votre téléphone à portée :</strong> le magasin peut vous appeler pour confirmer votre adresse avant l'expédition.
          </div>
        </div>

        <button
          type="button"
          onClick={onClose}
          className="btn-submit-order"
          style={{ width: '100%', marginTop: 8 }}
        >
          <Package size={18} />
          <span>Continuer mes achats</span>
          <ArrowRight size={16} />
        </button>
      </div>
    </div>
  );
};
